import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { matchFilterString, sortArrayBy } from '@domain-group/javascript-utils'

import { useLoadMore, useWatchEntityUpdates } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

const watchEntityKeys = ['paymentMethods']

const usePaymentMethods = (options = {}) => {
  const { filters } = options
  const {
    string,
  } = filters || {}

  const {
    updatedEntities: { paymentMethods: paymentMethodsUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const paymentMethods = useSelector(reduxState => reduxState.entities.paymentMethods)

  const filteredPaymentMethods = useMemo(() => {
    const filtered = Object.values(paymentMethods).filter((paymentMethod) => {
      const { title } = paymentMethod

      const matchTitle = matchFilterString(title, string)

      return matchTitle
    })

    return sortArrayBy(filtered, 'asc', 'title')
  }, [paymentMethodsUpdatedAt, JSON.stringify(options)])

  const filteredPaymentMethodsCount = filteredPaymentMethods.length

  const loadMorePayload = useLoadMore({
    loadedCount: filteredPaymentMethodsCount,
    filters,
    performHttpRequests: options.performHttpRequests,
  })

  const {
    callbacks: { loadMore },
    canLoadMore,
    filtersWithOffset,
    limit,
    performHttpRequests,
  } = loadMorePayload

  const { loading: loadingPaymentMethods } = useReduxAction(
    'paymentMethods',
    'loadPaymentMethods',
    {
      ...filtersWithOffset,
      limit,
    },
    [performHttpRequests, filtersWithOffset],
    {
      shouldPerformFn: ({ loading }) => performHttpRequests && !loading,
    },
  )

  return {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredPaymentMethods,
    filteredPaymentMethodsCount,
    hasFilteredPaymentMethods: !!filteredPaymentMethodsCount,
    loading: loadingPaymentMethods,
  }
}

export default usePaymentMethods
